import styled, {CreateStyled} from 'react-emotion';
import {Theme} from '../theme';

export default styled as CreateStyled<Theme>;



// WEBPACK FOOTER //
// ./src/utils/styled.ts